module.exports = __webpack_public_path__ + "0-es2015.8de0217391828be02a24.worker.js"